import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';
import { Color } from '@/GlobalStyles';
import { useTranslation } from 'react-i18next';

export type DossierStatus = 'GRIS' | 'VERT' | 'ORANGE';

interface DossierStatusIndicatorProps {
  status: DossierStatus;
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
}

const DossierStatusIndicator: React.FC<DossierStatusIndicatorProps> = ({
  status,
  size = 'medium',
  showLabel = false,
}) => {
  const { t } = useTranslation();
  
  const getStatusColor = () => {
    switch (status) {
      case 'GRIS':
        return '#9E9E9E'; // Gris pour archivé
      case 'VERT':
        return '#4CAF50'; // Vert pour finalisé
      case 'ORANGE':
        return '#FF9800'; // Orange pour en cours
      default:
        return Color.colorGray_100;
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case 'GRIS':
        return t('Archivé');
      case 'VERT':
        return t('Finalisé');
      case 'ORANGE':
        return t('En cours');
      default:
        return '';
    }
  };

  const getDotSize = () => {
    switch (size) {
      case 'small':
        return 8;
      case 'medium':
        return 12;
      case 'large':
        return 16;
      default:
        return 12;
    }
  };

  const dotSize = getDotSize();

  return (
    <View style={styles.container}>
      <View
        style={[
          styles.dot,
          {
            width: dotSize,
            height: dotSize,
            borderRadius: dotSize / 2,
            backgroundColor: getStatusColor(),
          },
        ]}
      />
      {showLabel && (
        <Text style={[styles.label, { color: getStatusColor() }]}>
          {getStatusLabel()}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  dot: {
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.1)',
  },
  label: {
    fontSize: 12,
    fontWeight: '500',
  },
});

export default DossierStatusIndicator;